import axios from "axios";

export const ONBOARDED_BUT_NEEDS_LOC_REVIEW = "OnboardedButNeedsLocReview";

export type CustomerFeatureFlags = Record<string, boolean>;

const FeatureFlagRepo = {
  /** Fresh point lookup: rollout CTAs must reflect completion when returning to a page. */
  async getCustomerFlag(customerId: string, flagName: string): Promise<boolean> {
    const uri = `${import.meta.env.VITE_API_URL}/flags/customers/${encodeURIComponent(customerId)}/${encodeURIComponent(flagName)}`;
    const { data } = await axios.get<{ enabled: boolean }>(uri);
    return data.enabled === true;
  },
  async getCustomerFlags(customerId: string): Promise<CustomerFeatureFlags> {
    const uri = `${import.meta.env.VITE_API_URL}/flags/customers/${customerId}`;
    const { data } = await axios.get(uri);

    const raw: Record<string, boolean | null | undefined> = data?.flags ?? data?.Flags ?? {};
    // Necessary?
    const normalized: CustomerFeatureFlags = {};
    for (const [key, value] of Object.entries(raw)) {
      normalized[key] = value === true;
    }
    return normalized;
  },
};

export default FeatureFlagRepo;
